import { makeStyles } from 'tss-react/mui';

const useVendorStyles = makeStyles()((theme) => ({
  main: {
    width: 'auto',
  },
  mainContent: {
    display: 'flex',
    '&>article': {
      maxWidth: '45%',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      '&>article': {
        maxWidth: '100%',
      },
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      '&>article': {
        maxWidth: '100%',
      },
    },
  },
}));

export default useVendorStyles;
